export enum WorkflowViewType {
    Start,
    Condition,
    Action,
    End
}